// ตัวเลือก dropdown ของ GPT model ที่ใช้ซ้ำใน ModelManagement และ PlayGround
// component ควร copy ก่อนใช้ (เช่น DD_MODEL_OPTIONS.map((o) => ({ ...o }))) กัน mutation ข้ามหน้าจอ
export const DD_MINUTE_OPTIONS = [
	{ name: '0', value: 0 },
	{ name: '2', value: -2 },
	{ name: '10', value: -10 },
	{ name: '30', value: -30 },
	{ name: '60', value: -60 },
	{ name: '720', value: -720 },
	{ name: '1440', value: -1440 },
];

// PlayGround ไม่มี entry '0' — ใช้ชุดนี้แทน
export const DD_MINUTE_OPTIONS_NO_ZERO = DD_MINUTE_OPTIONS.slice(1);

export const DD_MODEL_OPTIONS = [
	{ provider: 'Azure', model: 'gpt-35-turbo-chat', maxPrompt: 4000 },
	{ provider: 'Azure', model: 'gpt-35-turbo-16k', maxPrompt: 8000 },
	{ provider: 'Azure', model: 'gpt-4', maxPrompt: 6000 },
	{ provider: 'Azure Postgresql', model: 'gpt-35-postgresql', maxPrompt: 4000 },
	{ provider: 'Azure Postgresql', model: 'gpt-35-16k-postgresql', maxPrompt: 8000 },
	{ provider: 'Azure Postgresql', model: 'gpt-4-postgresql', maxPrompt: 6000 },
	{ provider: 'Azure Internet', model: 'gpt-35-Internet', maxPrompt: 4000 },
	{ provider: 'Azure Internet', model: 'gpt-35-16k-Internet', maxPrompt: 8000 },
	{ provider: 'Azure Internet', model: 'gpt-4-Internet', maxPrompt: 6000 },
	{ provider: 'Azure News', model: 'gpt-35-turbo-chat', maxPrompt: 4000 },
	{ provider: 'Azure News', model: 'gpt-35-turbo-16k', maxPrompt: 8000 },
	{ provider: 'Azure News', model: 'gpt-4', maxPrompt: 6000 },
];

// name = fallback ภาษาอังกฤษ; i18nKey ใช้แปลตอน render (component map เป็น computed ให้ reactive ตาม locale)
export const DD_GENDER_OPTIONS = [
	{ id: 'm', name: 'Male', i18nKey: 'male' },
	{ id: 'f', name: 'Female', i18nKey: 'female' },
];

// เพดานค่า Max Input Length (ความยาวอินพุตสูงสุดต่อข้อความ) ให้ตรงกับ default 200000 ฝั่ง backend
export const MAX_CHAT_INPUT_LIMIT = 200000;
